<template>
  <div :class="['form-input-wrapper']">
    <CInput v-bind="options" :placeholder="placeholder" v-on="_listener_" v-model="data.model"
      :readonly="options.readonly" :class="{
        'input-valid-error': data.validator && !data.validator.isValid,
        'no-label': !(options && options.label)
      }">
      <label slot="label"
        :class="(options.horizontal && options.horizontal.label) ? 'col-form-label ' + options.horizontal.label : ''"
        v-html="options.label"></label>
      <label slot="append" v-if="options.append">{{ options.append }}</label>
    </CInput>
    <div class="form-row" v-show="!(data.validator ? data.validator.isValid : true)">
      <label slot="label"
        :class="(options.horizontal && options.horizontal.label) ? 'col-form-label ' + options.horizontal.label : ''">&nbsp;</label>
      <div class="valid-error" :class="(options.horizontal && options.horizontal.input) ? options.horizontal.input : ''">
        {{ data.validator ? data.validator.errorMessage : "" }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["options", "data", "listener"],
  data() {
    var that = this;
    return {
      lastValueUpdateTrigger: that.data.model
    };
  },
  created() {
  },
  mounted() {
  },
  updated() {
  },
  methods: {
    setLastValueUpdateTrigger: function () {
      this.lastValueUpdateTrigger = this.data.model;
    }
  },
  computed: {
    hasValid: function () {
      return this.data.validator && this.data.validator.valid;
    },
    hasUpdateTrigger: function () {
      return (
        typeof this.data.updateTrigger === "function" &&
        this.lastValueUpdateTrigger !== this.data.model
      );
    },
    hasUpdateCallback: function () {
      return typeof this.data.updateCallback === "function";
    },
    validOnInput: function () {
      return (
        this.options &&
        this.options.validOnInput &&
        this.data.validator &&
        this.data.validator.valid
      );
    },
    placeholder: function () {
      return this.options
        ? this.options.placeholder || this.options.label
        : this.data
          ? this.data.name
          : "";
    },
    _listener_: function () {
      let _listenter = {};
      let that = this;
      if (that.hasUpdateTrigger || that.hasUpdateCallback || that.hasValid) {
        _listenter.keyup = function (event) {
          let valid = true;
          if (that.validOnInput) {
            valid = that.data.validator.valid();
          }
          if (valid && that.hasUpdateTrigger && event.key === "Enter") {
            if (that.data.updateTrigger()) {
              that.data.updateTrigger().loadData();
            }
            that.setLastValueUpdateTrigger();
          }
          if (valid && that.hasUpdateCallback && event.key === "Enter") {
            that.data.updateCallback();
          }
        };

        _listenter.blur = function (event) {
          if (that.hasValid) {
            setTimeout(function () {
              var valid = that.data.validator.valid();
              if (valid && that.hasUpdateTrigger) {
                if (that.data.updateTrigger()) {
                  that.data.updateTrigger().loadData();
                }
                that.setLastValueUpdateTrigger();
              }
            }, 250);
          } else if (that.hasUpdateTrigger) {
            if (that.data.updateTrigger()) {
              that.data.updateTrigger().loadData();
            }
            that.setLastValueUpdateTrigger();
          }
        };
      }
      for (let attr in this.listener) {
        _listenter[attr] = this.listener[attr];
      }

      return _listenter;
    }
  },
  watch: {}
};
</script>
<style scoped></style>
